(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;

  var scrim = document.createElement('div');
  scrim.className = 'nav-scrim';
  document.body.appendChild(scrim);

  var close = function () {
    nav.classList.remove('is-open');
    scrim.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  };
  var open = function () {
    nav.classList.add('is-open');
    scrim.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  };
  toggle.addEventListener('click', function () {
    nav.classList.contains('is-open') ? close() : open();
  });
  scrim.addEventListener('click', close);

  // On mobile, tapping a dropdown parent expands its panel instead of navigating
  nav.querySelectorAll('.catbar__item.has-dd > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.innerWidth > 900) return;
      e.preventDefault();
      a.closest('.catbar__item').classList.toggle('is-open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// Pill variant picker → resolve the picked option combo to a real variant,
// then sync the buy form's hidden id, the price row and the ATC button.
(function () {
  var dataEl = document.querySelector('[data-pdp-variants]');
  var picker = document.querySelector('[data-pdp-picker]');
  if (!dataEl || !picker) return;
  var variants = JSON.parse(dataEl.textContent);
  var idInput = document.querySelector('[data-pdp-id]');
  var atc = document.querySelector('[data-pdp-atc]');
  var atcLabel = document.querySelector('[data-pdp-atc-label]');
  var priceEl = document.querySelector('[data-pdp-price]');
  var wasEl = document.querySelector('[data-pdp-was]');
  var saveEl = document.querySelector('[data-pdp-save]');

  // Selection state starts from the server-rendered .is-selected pills; option
  // rows with a single value are not rendered, so backfill from the current
  // variant (the one the hidden input points at).
  var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
  var selected = current ? current.options.slice() : [];

  function apply(v) {
    if (!v) return;
    idInput.value = v.id;
    priceEl.textContent = v.price;
    if (v.was) { wasEl.style.display = ''; wasEl.textContent = v.was; saveEl.style.display = ''; saveEl.textContent = (saveEl.dataset.saveTpl || 'Save [pct]%').replace('[pct]', v.save); }
    else { wasEl.style.display = 'none'; saveEl.style.display = 'none'; }
    if (v.available) { atc.disabled = false; atcLabel.textContent = atc.dataset.labelAdd || 'Add to cart'; }
    else { atc.disabled = true; atcLabel.textContent = atc.dataset.labelSold || 'Sold out'; }
  }

  picker.addEventListener('click', function (e) {
    var opt = e.target.closest('.variant-opt');
    if (!opt) return;
    var idx = +opt.dataset.optIndex;
    selected[idx] = opt.dataset.optValue;
    opt.closest('.variant-opts').querySelectorAll('.variant-opt').forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
    var match = variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
    apply(match);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekly-deal"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-countdown]').forEach(function (el) {
  var hb = el.querySelector('b[data-h]'), mb = el.querySelector('b[data-m]'), sb = el.querySelector('b[data-s]');
  if (!hb) return;
  var t = (+el.dataset.h) * 3600 + (+el.dataset.m) * 60 + (+el.dataset.s);
  var pad = function (n) { return String(n).padStart(2, '0'); };
  setInterval(function () {
    t = t > 0 ? t - 1 : 0;
    hb.textContent = pad(Math.floor(t / 3600));
    mb.textContent = pad(Math.floor((t % 3600) / 60));
    sb.textContent = pad(t % 60);
  }, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
